import {
  RiskRewardSentenceRow,
  RiskRewardIconSkeleton,
  RiskRewardTextSkeleton,
} from './styled';

const RiskRewardSkeleton = () => {
  return (
    <RiskRewardSentenceRow>
      <RiskRewardIconSkeleton />
      <RiskRewardTextSkeleton />
    </RiskRewardSentenceRow>
  );
};

export default RiskRewardSkeleton;
